import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@app/core/services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { navigateNotFound } from '@app/shared/utils';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

const PASSWORD_MIN_LEN = 8;

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  form: FormGroup;

  apiErrors = {};

  isLoading = false;
  isSuccessfullyChanged: boolean;

  token: string;

  ngUnsubscribe = new Subject();

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      password: ['', [ Validators.required, Validators.minLength(PASSWORD_MIN_LEN) ]],
      repeat_password: ['', [Validators.required, Validators.minLength(PASSWORD_MIN_LEN) ]],
    });

    this.route.params
      .map(p => p['token'])
      .map(token => token ? token : navigateNotFound(this.router))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(token => this.token = token);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  submit() {
    if (this.isLoading) return;

    const pass = this.form.get('password').value;
    const repeatPass = this.form.get('repeat_password').value;

    if (pass === '' || repeatPass === '' || pass !== repeatPass) {
      this.apiErrors['non_field_error'] = 'Пароли не совпадают';
      return;
    }
    this.isLoading = true;

    this.apiErrors = {};

    this.authService.resetPassword(this.form.get('password').value, this.token)
      .pipe(takeUntil(this.ngUnsubscribe))
      .finally(() => this.isLoading = false)
      .subscribe(response => this.isSuccessfullyChanged = true, error => this.apiErrors = error.error);
  }
}



// WEBPACK FOOTER //
// ./src/app/accounts/reset-password/reset-password.component.ts